import type { MouseEvent } from 'react';

import type { ProductStyle } from 'types/cloudCatalog';
import type { SelectedSizing } from 'types/product';
import type { FormattedProductBundle } from 'reducers/detail/productDetail';
import { stripSpecialChars } from 'helpers/index';
import { getColorsBySize, getMatchingProductStyles, getSelectedSizing } from 'helpers/ProductUtils';
import { buildSeoProductUrl } from 'helpers/SeoUrlBuilder';
import MelodyCardProduct from 'components/common/melodyCard/MelodyCardProduct';

interface OutOfStockAltListProps {
  detail: FormattedProductBundle;
  onStyleChange?: (e: MouseEvent<HTMLButtonElement>) => void;
  productStyles: Record<string, ProductStyle>;
  selectedSizing: SelectedSizing;
  sizeId: string;
}

export const OutOfStockAltList = ({ detail, onStyleChange, productStyles, selectedSizing, sizeId }: OutOfStockAltListProps) => {
  const {
    sizing: { dimensions, stockData }
  } = detail;
  const newSelectedSizing = getSelectedSizing(selectedSizing, dimensions, sizeId);
  const colorsBySize = getColorsBySize(stockData, newSelectedSizing);

  // Render sizing values only if there are available colors in stock
  if (!colorsBySize.length) {
    return null;
  }

  const matches = getMatchingProductStyles({ colorsBySize, productStyles });

  const onComponentClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onStyleChange?.(e);
  };

  return (
    <>
      {matches.map(styleId => {
        const style = productStyles[styleId]!;
        const { colorId, price, images, color } = style;
        const mainImage = images.find(imgs => imgs.type === 'PAIR' || imgs.type === 'MAIN');
        const imageId = mainImage ? mainImage.imageId : null;
        const msaImageParams = { height: 83, width: 110, autoCrop: true };
        const seoUrl = buildSeoProductUrl(detail, colorId);
        const cardData = {
          alt: color,
          colorName: color,
          link: seoUrl,
          colorId,
          imageId,
          price,
          styleId
        };

        return (
          <MelodyCardProduct
            key={`${stripSpecialChars(imageId)}_${styleId}`}
            cardData={cardData}
            componentStyle="oos"
            data-style-id={styleId}
            melodyCardTestId="OOS"
            msaImageParams={msaImageParams}
            onComponentClick={onComponentClick}
          />
        );
      })}
    </>
  );
};
